export default "__VITE_ASSET__DomwoRnN__"